import React from 'react';
import './ErrorPage.css';

function ErrorPage() {
  return (
    <section className="page_404">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="col-sm-10 col-sm-offset-1 text-center">
              <div className="four_zero_four_bg">
                <h1 className="text-center">404</h1>
              </div>
              <div className="content_box_404">
                <h3 className="h3">Oops! Something's Under Construction</h3>
                <p>
                  We're working hard to make this page amazing. Please check
                  back later or return to the home page to continue exploring.
                </p>
                <a href="/" className="home_link">
                  Go Back to Home
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ErrorPage;